import React from 'react'
import APIKeysInfo from 'src/app/APIProduct/APIKeys/APIKeys'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { apiKeysProfileRouteProps } from 'src/navigation/routeProps'

const ProfileApiKeysAppRoute: AppRoute = {
  id: AppLocation.ProfileApiKeys,
  routeProps: apiKeysProfileRouteProps,
  component: <APIKeysInfo />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ProfileApiKeysAppRoute
